import actions from './constants';

export const updateQueryFilterField = (
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  name,
) => ({
  type: actions.UPDATE_QUERY_FILTER_FIELD,
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  name,
});

export const updateQueryFilterValues = (
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  values,
) => ({
  type: actions.UPDATE_QUERY_FILTER_VALUES,
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  values,
});

export const updateQueryFilterOperator = (
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  operator,
) => ({
  type: actions.UPDATE_QUERY_FILTER_OPERATOR,
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  operator,
});

export const updateQueryFilterJoin = (
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  dictionaryCode,
  name,
) => ({
  type: actions.UPDATE_QUERY_FILTER_JOIN,
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  dictionaryCode,
  name,
});

export const addQueryFilter = (category, code, queryUUID, clauseUUID, name) => ({
  type: actions.ADD_QUERY_FILTER,
  category,
  code,
  queryUUID,
  clauseUUID,
  name,
  cascade: true,
});

export const removeFilterFromCohort = (
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  dictionaryCode,
) => ({
  type: actions.REMOVE_FILTER_FROM_COHORT,
  category,
  code,
  queryUUID,
  clauseUUID,
  filterUUID,
  dictionaryCode,
  cascade: true,
});
